import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Avatar,
    Skeleton,
    Stack,
    IconButton,
} from "@mui/material";
import { ArrowForward, Mic, Search } from '@mui/icons-material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { RiHospitalLine } from 'react-icons/ri';
import { useNavigate } from "react-router-dom";
import { get, post } from "../../utility/fetchWeb";
import { get as gets } from "../../utility/fetch";

import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useDrawer } from "../../contexts/DrawerContext";
import MapSelector from "../Layout/MapSelector";
import VoiceRecorder from '../inputs/VoiceRecorder';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import PaymentModal from "../Layout/PaymentModal";
import BankPaymentModal from "../Layout/BankPaymentModal";
import PaymentConfirmationModal from "../Layout/PaymentConfirmationModal";
import LaboratoryChatModal from "../modals/LaboratoryChatModal";
import PromoBanner from "../Layout/PromoBanner";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import VideoCalling from '../Layout/VideoCalling';
import Pagination from "../Layout/Pagination";

// const categories = ["General", "Dermato", "Physiologist", "Cardiologist"];

export default function PharmacyPage() {
    const [selectedCategory, setSelectedCategory] = useState("General");
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [categories, setCategories] = React.useState([]);
    const [engagedDoctors, setEngagedDoctors] = React.useState([]);
    const [searchText, setSearchText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);

    const [currentLocation, setCurrentLocation] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [isVoiceModalOpen, setIsVoiceModalOpen] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const [recommendedPharmacies, setRecommendedPharmacies] = useState([]);
    const [showVoiceResults, setShowVoiceResults] = useState(false);

    const [selectedPharmacy, setSelectedPharmacy] = useState(null);
    const [medications, setMedications] = useState([]);
    const [medicationsLoading, setMedicationsLoading] = useState(false);
    const [medicationsModalOpen, setMedicationsModalOpen] = useState(false);
    const [medicationSearch, setMedicationSearch] = useState("");
    const [isVoiceDrugModalOpen, setIsVoiceDrugModalOpen] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [openBankModal, setOpenBankModal] = useState(false);
    const [service, setService] = useState({});
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [medicationInput, setMedicationInput] = useState("");
    const [isChatModalOpen, setIsChatModalOpen] = useState(false);
    const [selectedPharmacyForChat, setSelectedPharmacyForChat] = useState(null);
    const [targetedAds, setTargetedAds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [showVideoChatModal, setShowVideoChatModal] = useState(false);
    const [startAudioOnly, setStartAudioOnly] = useState(false);
    const [appId, setAppId] = useState(process.env.REACT_APP_AGORA_KEY);
    const [channel, setChannel] = useState("call");
    const [token, setToken] = useState(null);
    const [uid, setUid] = useState(sessionStorage.getItem("userId") || "defaultUid");
    const [selectedPharmacyForCall, setSelectedPharmacyForCall] = useState(null);
    const [callId, setCallId] = useState(null); // Add callId state
    const query = new URLSearchParams(window.location.search);
    const chatId = query.get("rrt");

    const name = sessionStorage.getItem("name").toString();


    const handleLocationSelect = (location, address) => {
        console.log("Selected Location:", location);
        console.log("Selected Address:", address);

    };



    const { toggleAdmissionDetailsDrawer, setComponent } = useDrawer();

    const getEngagedDoctors = async () => {

        try {
            const response = await get(`/Doctors/EngagedDoctors/${sessionStorage.getItem("userId")}`);
            console.log('Response:', response);
            setEngagedDoctors(response);
        } catch (error) {
            console.error("Error fetching doctors:", error);
        }
    }

    const handleToggle = () => {
        setComponent("chat");


    }

    const notifyCaller = async (chann, id) => {
        try {
            const res = await post(`/Posts/notify-call`, {
                receiverId: parseInt(id),
                channelName: chann,
                callerId: Number(sessionStorage.getItem("userId")),
                callerName: sessionStorage.getItem("name"),
                userType: 2 // for practitioner 1 for patient
            });
            console.log(res)
            if (res?.data) {
                console.log("Caller notified successfully");
            } else {
                console.error("Failed to notify caller:", res);
            }
        } catch (error) {
            console.error("Error notifying caller:", error);
        }
    }

    const getTargetedAds = async () => {
        try {
            const userId = sessionStorage.getItem('userId');
            const pageName = 'Pharmacy Search';
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/connecthealthadmin/api/ad/find-ad?Id=${userId}&page=${pageName}`);

            if (response.ok) {
                const data = await response.json();
                const transformedAds = data.map(ad => ({
                    id: ad.id,
                    imageUrl: ad.bannerImageUrl,
                    title: ad.title,
                    subtitle: ad.description,
                    redirectUrl: ad.redirectUrl,
                    status: 1,
                    isTargeted: true
                }));
                setTargetedAds(transformedAds);
            }
        } catch (error) {
            console.error('Error fetching targeted ads:', error);
            setTargetedAds([]);
        }
    };

    const getHealthCareProvider = async (page = 1) => {
        setIsLoading(true);
        try {
            let response;

            response = await get(`/HealthCareProvider/list/HealthCareProviderCategory/${2}/true?pageNumber=${page}&pageSize=10`);
            console.log('Response:', response);
            setData(response?.data?.recordList);
            setFilteredData(response?.data?.recordList);
            setTotalPages(response?.data?.metadata.totalPages || 1);
            setCurrentPage(response?.data?.metadata.page || 1);
            setIsLoading(false);

        } catch (error) {
            console.error('Error fetching doctors:', error);
            setIsLoading(false);
        }
    }

    const getSearchedHealthCareProvider = async (searchText, page = 1) => {
        setIsLoading(true);
        try {
            let response;

            response = await get(`/HealthCareProvider/filter-list/true/categoryType/Pharmacy/Name/${searchText}?pageNumber=${page}&pageSize=10`);
            console.log('Response:', response);
            setData(response?.data?.recordList);
            setFilteredData(response?.data?.recordList);
            setTotalPages(response?.data?.metadata.totalPages || 1);
            setCurrentPage(response?.data?.metadata.page || 1);
            setIsLoading(false);

        } catch (error) {
            console.error('Error fetching doctors:', error);
            setData([]);
            setFilteredData([]);
            setIsLoading(false);

        }
    }

    const handleChange = (event) => {
        const { value } = event.target;
        console.log("Search Text:", value);
        // if (value.length < 3) {
        //     return;
        // }
        setSearchText(value);
        if (value.length >= 2) {
            getSearchedHealthCareProvider(value, currentPage);
        } else if (value.length === 0) {
            getHealthCareProvider();
        }
    }

    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearchQuery(value);
        if (value.length >= 2) {
            getSearchedHealthCareProvider(value, currentPage);
        } else if (value.length === 0) {
            getHealthCareProvider();
        }
    };

    const handleMicClick = () => {
        setIsVoiceModalOpen(true);
    };

    const handleTranscript = async (transcript) => {
        setIsLoading(true);
        setSearchQuery(transcript);
        setIsListening(true);
        try {
            // You can implement pharmacy recommendation API here if available
            setShowVoiceResults(true);
            setIsVoiceModalOpen(false);
        } catch (error) {
            console.error('Error fetching pharmacies:', error);
        } finally {
            setIsListening(false);
            setIsLoading(false);
        }
    };

    const getcategories = async () => {
        try {
            const response = await get('/categories'); // Replace with your API endpoint
            console.log(response);
            setCategories(response.data); // Assuming the response contains the categories data
            // Handle the fetched categories data as needed
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    }

    // Fetch medications for a pharmacy
    const fetchMedications = async (pharmacyId, query = "") => {
        setMedicationsLoading(true);
        setMedicationInput(query)
        try {
            let response;
            if (query) {
                response = await gets(`/pharmacyestore/filter-list/healthcareprovider/${pharmacyId}/Name/${query}/1/10`);
                setIsVoiceDrugModalOpen(false);
            } else {
                response = await gets(`/pharmacyestore/list/healthcareprovider/${pharmacyId}/1/10`);
                setIsVoiceDrugModalOpen(false);
            }
            setMedications(response?.data?.recordList || []);
            setIsVoiceDrugModalOpen(false);
        } catch (error) {
            setMedications([]);
            setIsVoiceDrugModalOpen(false);
        }
        setMedicationsLoading(false);
    };

    // Open modal and fetch medications
    const handleOpenMedicationsModal = async (pharmacy) => {
        setSelectedPharmacy(pharmacy);
        setMedicationsModalOpen(true);
        setMedicationSearch("");
        await fetchMedications(pharmacy.id);
    };

    // Close modal
    const handleCloseMedicationsModal = () => {
        setMedicationsModalOpen(false);
        setSelectedPharmacy(null);
        setMedications([]);
        setMedicationSearch("");
        setIsVoiceDrugModalOpen(false);
    };

    // Handle medication search
    const handleMedicationSearchChange = async (e) => {
        const value = e.target.value;
        setMedicationSearch(value);
        if (selectedPharmacy) {
            await fetchMedications(selectedPharmacy.id, value);
        }
    };

    // Handle voice search for medications
    const handleMedicationVoiceSearch = () => {
        setIsVoiceDrugModalOpen(true);
    };

    const handleMessageClick = (e, pharmacy) => {
        e.stopPropagation(); // Prevent the card's onClick from firing
        setSelectedPharmacyForChat(pharmacy);
        setIsChatModalOpen(true);
    };

    const handleMedicationVoiceTranscript = async (transcript) => {
        setMedicationSearch(transcript);
        if (selectedPharmacy) {
            await fetchMedications(selectedPharmacy.id, transcript);
        }
        setIsVoiceDrugModalOpen(false);
    };

    const getAgoraDetails = async (receiverId) => {
        try {
            const res = await get(`/posts/generate-new-token?channelName=${`connecthealthpro_videocall-${uid}&${receiverId}`}&uid=${uid}`);
            if (res && res.token) {
                setToken(res.token);
                setUid(Number(res.uid) || uid);
                setAppId(res.appId || process.env.REACT_APP_AGORA_KEY);
                setChannel(res.channelName || "call");
                return true;
            }
            return false;
        } catch (error) {
            console.error("Error fetching Agora token:", error);
            return false;
        }
    };

    const handleVideoCall = async (e, pharmacy) => {
        e.stopPropagation();
        setSelectedPharmacyForCall(pharmacy);
        const success = await getAgoraDetails(pharmacy.contactPersonId);
        if (success) {
            setStartAudioOnly(false);
            setCallId(Date.now()); // Generate unique callId
            setShowVideoChatModal(true);
            notifyCaller(`${`connecthealthpro_videocall-${uid}&${pharmacy.contactPersonId}`}`, pharmacy.contactPersonId);
        }
    };

    const handleAudioCall = async (e, pharmacy) => {
        e.stopPropagation();
        setSelectedPharmacyForCall(pharmacy);
        const success = await getAgoraDetails(pharmacy.contactPersonId);
        if (success) {
            setStartAudioOnly(true);
            setCallId(Date.now()); // Generate unique callId
            setShowVideoChatModal(true);
            notifyCaller(`${`connecthealthpro_audiocall-${uid}&${pharmacy.contactPersonId}`}`, pharmacy.contactPersonId);
        }
    };

    const handleCloseVideoChat = () => {
        setShowVideoChatModal(false);
        setToken(null);
        setSelectedPharmacyForCall(null);
        setCallId(null); // Reset callId
    };

    useEffect(() => {
        getTargetedAds();
        getHealthCareProvider();
        getEngagedDoctors();

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setCurrentLocation({ lat: latitude, lng: longitude });
                },
                (error) => {
                    console.error("Error getting current location:", error);
                }
            );
        }
    }, [])

    useEffect(() => {
        if (searchQuery.length >= 3) {
            getSearchedHealthCareProvider(searchQuery, currentPage);
        } else if (searchQuery.length === 0) {
            getHealthCareProvider(currentPage);
        }
    }, [searchQuery]);

    return (
        <div className="pharmacy-page w-100">
            <Box display="flex" alignItems="center">
                <Avatar sx={{ width: 64, height: 64, mr: 3, backgroundColor: 'primary.main' }}>
                    <AccountCircleIcon fontSize="large" />
                </Avatar>
                <Box>
                    <Typography variant="subtitle2" color="text.secondary">Good Day</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 0.5 }}>{name}</Typography>
                </Box>
            </Box>

            {/* Search Bar Section */}
            <div className="search-section">
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Search for pharmacies..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                    />
                    {(searchQuery) && (
                        <button
                            className="clear-button"
                            onClick={() => {
                                setSearchQuery('');
                            }}
                        >
                            ×
                        </button>
                    )}
                </div>
                <Tooltip title="Voice search for pharmacy" arrow placement="top">
                    <div className="filter-btn" onClick={handleMicClick}>
                        <Mic color='white' />
                    </div>
                </Tooltip>
            </div>

            {/* Filter Bar */}
            <Box display="flex" flexDirection={"column"} justifyContent="flex-end" gap={2} mt={2} mb={3}>
                <Box sx={{ flex: 1 }}>
                    <MapSelector
                        onLocationSelect={handleLocationSelect}
                        currentLocation={currentLocation}
                    />
                </Box>
                {/* Add PromoBanner after search section */}
                {targetedAds.length > 0 && (
                    <Box sx={{ mb: 3 }}>
                        <PromoBanner ads={targetedAds} page={'Pharmacy Search'} />
                    </Box>
                )}
            </Box>

            <>
                {/* Voice Search Modal */}
                {isVoiceModalOpen && (
                    <VoiceRecorder
                        onTranscript={async (transcript) => {
                            if (transcript) {
                                await handleTranscript(transcript);
                                setShowVoiceResults(true);
                            }
                            setIsVoiceModalOpen(false);
                            setIsListening(false);
                        }}
                        provider={"Pharmacy"}

                    />
                )}

                {isLoading ? (
                    <div className="pharmacy-list">
                        {[...Array(6)].map((_, index) => (
                            <div key={index} className="pharmacy-card">
                                <Skeleton variant="circular" width={56} height={56} />
                                <div className="pharmacy-info">
                                    <Skeleton variant="text" width="60%" height={20} />
                                    <Skeleton variant="text" width="80%" height={24} />
                                    <Skeleton variant="text" width="90%" height={16} />
                                </div>
                                <div className="doctor-info">
                                    <Skeleton variant="text" width="70%" height={20} />
                                    <Skeleton variant="text" width="50%" height={16} />
                                </div>
                                <Stack direction="row" spacing={1}>
                                    <Skeleton variant="circular" width={40} height={40} />
                                    <Skeleton variant="circular" width={40} height={40} />
                                    <Skeleton variant="circular" width={40} height={40} />
                                </Stack>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="pharmacy-list">
                        {data?.length > 0 ? (
                            <>
                                {data.map((pharmacy) => (
                                    <div
                                        key={pharmacy.id}
                                        className="pharmacy-card"
                                        onClick={() => navigate(`/profile?cat=caregiverPhar&id=${pharmacy?.id}`, { state: { providerData: pharmacy } })}
                                    >
                                        <div className="pharmacy-icon">
                                            <Avatar
                                                src={pharmacy?.logoPath}
                                                sx={{ width: 56, height: 56, backgroundColor: 'white' }}
                                                variant="rounded"
                                            >
                                                {!pharmacy?.logoPath && <RiHospitalLine size={32} color="white" />}
                                            </Avatar>
                                        </div>

                                        <div className="pharmacy-info">
                                            <div className="pharmacy-type">
                                                {pharmacy.healthCareProviderCategory?.name || 'Pharmacy'}
                                            </div>
                                            <h4 className="pharmacy-name">{pharmacy?.name}</h4>
                                            <p className="pharmacy-address">
                                                {pharmacy?.location || 'No location provided'}
                                            </p>
                                        </div>

                                        <div className="doctor-info">
                                            <h5 className="doctor-name">Medications</h5>
                                            <p className="doctor-role">Prescriptions & OTC</p>
                                        </div>

                                        <Stack direction="row" spacing={1}>
                                            <Tooltip title="Order Medication" arrow>
                                                <IconButton
                                                    size="small"
                                                    color="primary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleOpenMedicationsModal(pharmacy);
                                                    }}
                                                >
                                                    <ShoppingCartOutlinedIcon fontSize="medium" />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip title="Message Pharmacy" arrow>
                                                <IconButton
                                                    size="medium"
                                                    color="primary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleMessageClick(e, pharmacy);
                                                    }}
                                                >
                                                    <ChatBubbleOutlineIcon fontSize="medium" />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip title="Video Call" arrow>
                                                <IconButton
                                                    size="medium"
                                                    color="primary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleVideoCall(e, pharmacy);
                                                    }}
                                                >
                                                    <VideocamOutlinedIcon fontSize="medium" />
                                                </IconButton>
                                            </Tooltip>

                                            <Tooltip title="Audio Call" arrow>
                                                <IconButton
                                                    size="medium"
                                                    color="primary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleAudioCall(e, pharmacy);
                                                    }}
                                                >
                                                    <PhoneOutlinedIcon fontSize="medium" />
                                                </IconButton>
                                            </Tooltip>
                                        </Stack>
                                    </div>
                                ))}

                                <LaboratoryChatModal
                                    open={isChatModalOpen}
                                    handleClose={() => {
                                        setIsChatModalOpen(false);
                                        setSelectedPharmacyForChat(null); // Clear when closing
                                    }}
                                    selectedLab={selectedPharmacyForChat}
                                />
                            </>
                        ) : (
                            <Box sx={{ textAlign: "center", mt: 4 }}>
                                <Typography variant="h6" color="text.secondary">
                                    We couldn't find any pharmacy matching your search.
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    You can browse through the available pharmacies below, search by name, or try a different location.
                                </Typography>
                            </Box>
                        )}
                    </div>
                )}

                {/* Medications Modal */}
                <Modal
                    open={medicationsModalOpen}
                    onClose={handleCloseMedicationsModal}
                    aria-labelledby="medications-modal-title"
                    aria-describedby="medications-modal-description"
                    sx={{
                        '& .MuiBackdrop-root': { backgroundColor: 'rgba(0,0,0,0.5)' }
                    }}
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '50vw',
                        maxWidth: '1200px',
                        bgcolor: 'background.paper',
                        borderRadius: 3,
                        boxShadow: 24,
                        p: 4,
                        height: '80vh',
                        overflowY: 'auto',
                        '::-webkit-scrollbar': { display: 'none' },
                        scrollbarWidth: 'none'
                    }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography id="medications-modal-title" variant="h6" component="h2">
                                {selectedPharmacy?.name} - Available Medications
                            </Typography>
                            <IconButton onClick={handleCloseMedicationsModal}>
                                <CloseIcon />
                            </IconButton>
                        </Stack>
                        <Box display="flex" gap={1} mb={2}>
                            <input
                                type="text"
                                placeholder="Search for medications..."
                                value={medicationSearch}
                                onChange={handleMedicationSearchChange}
                                style={{
                                    flex: 1,
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #e0e0e0',
                                    fontSize: '15px'
                                }}
                            />
                            <IconButton onClick={handleMedicationVoiceSearch} color="primary">
                                <Mic />
                            </IconButton>
                        </Box>
                        {isVoiceDrugModalOpen && (
                            <Box sx={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100vw',
                                height: '100vh',
                                bgcolor: 'rgba(0,0,0,0.3)',
                                zIndex: 1300,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <Box sx={{
                                    position: 'relative',
                                    bgcolor: 'background.paper',
                                    borderRadius: 2,
                                    boxShadow: 8,
                                    p: 3,
                                    minWidth: 320,
                                    maxWidth: 400,
                                    width: '90vw'
                                }}>
                                    <IconButton
                                        sx={{ position: 'absolute', top: 8, right: 8, zIndex: 10 }}
                                        onClick={() => setIsVoiceDrugModalOpen(false)}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                    <VoiceRecorder
                                        onTranscript={async (transcript) => {
                                            if (transcript) {
                                                await handleMedicationVoiceTranscript(transcript);

                                            }
                                            setIsVoiceModalOpen(false);
                                            setIsListening(false);
                                        }}

                                        provider={"Medication"}
                                    />
                                </Box>
                            </Box>
                        )}
                        {medicationsLoading ? (
                            <Stack gap={2}>
                                {[...Array(5)].map((_, idx) => (
                                    <Skeleton key={idx} variant="rectangular" height={48} />
                                ))}
                            </Stack>
                        ) : (
                            <Stack gap={2}>
                                {medications.length === 0 ? (
                                    <Typography color="text.secondary">No medications found.</Typography>
                                ) : (
                                    medications.map((med) => (
                                        <Box key={med.id} sx={{
                                            p: 2,
                                            borderRadius: 1,
                                            bgcolor: '#f8f9fa',
                                            boxShadow: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: 0.5,
                                            cursor: 'pointer',
                                            '&:hover': { backgroundColor: '#e9ecef' }
                                        }}
                                            onClick={() => {
                                                setShowPaymentModal(true);
                                                setMedicationsModalOpen(false);
                                                setService(med);
                                            }}>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                {med.productName}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                ₦{med.sellingPrice}
                                            </Typography>
                                        </Box>
                                    ))
                                )}
                            </Stack>
                        )}
                    </Box>
                </Modal>

                {showPaymentModal && <PaymentModal open={showPaymentModal} onClose={() => setShowPaymentModal(false)} service={service} hcProviderType={"pharmacy"} hcProvider={selectedPharmacy} openBankModal={() => setOpenBankModal(true)} />}
                {openBankModal && (
                    <BankPaymentModal
                        open={openBankModal}
                        onClose={() => setOpenBankModal(false)}
                        hcProviderType={"pharmacy"}
                        hcProvider={selectedPharmacy}
                        service={service}
                        onPay={() => {
                            setOpenBankModal(false);
                            setOpenConfirmationModal(true);
                        }}
                    />
                )}
                {
                    <PaymentConfirmationModal
                        open={openConfirmationModal}
                        onClose={() => setOpenConfirmationModal(false)}
                        userName={sessionStorage.getItem("name") || "User"}
                        doctorName={"Dr " + data?.firstName + " " + data?.lastName || "Doctor"}
                        service={service}
                        hcProviderType={"pharmacy"}
                        hcProvider={selectedPharmacy}
                        onAddToCalendar={() => {
                            setOpenConfirmationModal(false);
                            navigate(`/profile?cat=caregiverPhar&id=${selectedPharmacy?.id}`, { state: { providerData: selectedPharmacy } })
                            //   setRatingOpen(true);
                        }}
                    // onDoAnotherTime={handleAnotherTimeAction}
                    />
                }

                {!isLoading &&  (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={getHealthCareProvider}
                    />
                )}

                {showVideoChatModal && selectedPharmacyForCall && (
                    <VideoCalling
                        appId={appId}
                        channel={channel}
                        token={token}
                        uid={uid}
                        callId={callId} // Pass callId
                        open={showVideoChatModal}
                        onClose={handleCloseVideoChat}
                        startWithVideoOff={startAudioOnly}
                        isAudio={startAudioOnly}
                    />
                )}

                <style jsx>{`
                .pharmacy-page {
                    padding: 24px;
                    margin: 0 auto;
                }

                .search-section {
                    display: flex;
                    gap: 12px;
                    margin: 24px 0;
                    align-items: center;
                }

                .search-bar {
                    flex: 1;
                    position: relative;
                    display: flex;
                    align-items: center;
                    background: #f8f9fa;
                    border-radius: 12px;
                    padding: 0 16px;
                    border: 1px solid #e9ecef;
                }

                .search-icon {
                    color: #6c757d;
                    margin-right: 12px;
                }

                .search-bar input {
                    flex: 1;
                    border: none;
                    background: transparent;
                    padding: 16px 0;
                    font-size: 16px;
                    outline: none;
                }

                .search-bar input::placeholder {
                    color: #6c757d;
                }

              
                .filter-btn:hover {
                    transform: scale(1.05);
                }

                .pharmacy-list {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }

                .pharmacy-card {
                    display: flex;
                    align-items: center;
                    padding: 20px;
                    background: white;
                    border-radius: 12px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    cursor: pointer;
                    transition: transform 0.2s, box-shadow 0.2s;
                    gap: 16px;
                }

                .pharmacy-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
                }

                

                .pharmacy-info {
                    flex: 1;
                    min-width: 0;
                }

                .pharmacy-type {
                    color: #6c757d;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-bottom: 4px;
                }

                .pharmacy-name {
                    font-size: 18px;
                    font-weight: 600;
                    color: #212529;
                    margin: 0 0 8px 0;
                }

                .pharmacy-address {
                    color: #6c757d;
                    font-size: 14px;
                    margin: 0;
                }

                .doctor-info {
                    flex: 1;
                    min-width: 0;
                    text-align: right;
                }

                .doctor-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #212529;
                    margin: 0 0 4px 0;
                }

                .doctor-role {
                    color: #6c757d;
                    font-size: 12px;
                    margin: 0;
                }
            `}</style>
            </>
        </div>
    );
}
